import React, {useEffect, useRef, useState} from "react";
import "../DesignerRenderer.css";
import {getLiveTagValueByName} from "../utils";

const TagRenderer = ({
                         object,
                         latestTags,
                         styleJson,
                         dataJson,
                         commonStyle,
                         handleMouseDown,
                         onButtonAction,
                         renderSelectionHandles,
                     }) => {
    const initializedAnalogRef = useRef(false);
    const [analogInputValue, setAnalogInputValue] = useState("");
    const [isAnalogDirty, setIsAnalogDirty] = useState(false);

    const tagMode = dataJson.tag_mode || "manual";
    const objectMode = dataJson.object_mode || "monitor";
    const controlType = dataJson.control_type || "digital";
    const realtimeTagName = dataJson.tag_name || "";

    const prefix = dataJson.prefix || "";
    const suffix = dataJson.suffix || "";
    const unit = dataJson.unit || "";

    const getLiveValue = () => getLiveTagValueByName(latestTags, realtimeTagName);

    useEffect(() => {
        initializedAnalogRef.current = false;
        setIsAnalogDirty(false);
        setAnalogInputValue("");
    }, [object.id, dataJson.tag_name, dataJson.control_type, dataJson.object_mode]);

    useEffect(() => {
        if (objectMode !== "control" || controlType !== "analog") return;
        if (initializedAnalogRef.current) return;

        setAnalogInputValue(getLiveValue());
        initializedAnalogRef.current = true;
    }, [objectMode, controlType, realtimeTagName, latestTags]);

    let resolvedValue = dataJson.value ?? "N/A";

    if (tagMode === "realtime" && realtimeTagName) {
        const liveValue = getLiveValue();
        resolvedValue = liveValue !== "" ? liveValue : "N/A";
    }

    const selectedHandles = renderSelectionHandles();

    const handleLocalMouseDown = (e) => {
        e.stopPropagation();
        handleMouseDown?.(e);
    };

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            onMouseDown={handleLocalMouseDown}
            className="dr-object dr-tag"
            style={{
                position: "absolute",
                ...commonStyle,
                fontSize: styleJson.fontSize || 16,
                fontWeight: styleJson.fontWeight || "normal",
                fontFamily: styleJson.fontFamily || "Arial",

                // 👇 کنترل بکگراند
                background: styleJson.hasBackground
                    ? styleJson.backgroundColor || "#e0f2fe"
                    : "transparent",

                borderRadius: styleJson.borderRadius || 0,
                padding: styleJson.hasBackground ? styleJson.padding || 4 : 0,

                outline: selectedHandles ? "2px solid #2563eb" : "none",
                outlineOffset: selectedHandles ? "2px" : "0",
            }}
        >
            <div className="dr-tag-content">
                {prefix}
                {String(resolvedValue)}
                {unit}
                {suffix}
            </div>

            {objectMode === "control" && !object.locked && (
                <div
                    className="dr-control-group"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                >
                    {controlType === "digital" ? (
                        <>
                            <button
                                type="button"
                                className="dr-control-btn dr-control-btn--green"
                                onClick={() =>
                                    typeof onButtonAction === "function" &&
                                    onButtonAction({
                                        ...object,
                                        __controlType: "digital",
                                        __controlValue: 1,
                                    })
                                }
                            >
                                ON
                            </button>

                            <button
                                type="button"
                                className="dr-control-btn dr-control-btn--red"
                                onClick={() =>
                                    typeof onButtonAction === "function" &&
                                    onButtonAction({
                                        ...object,
                                        __controlType: "digital",
                                        __controlValue: 0,
                                    })
                                }
                            >
                                OFF
                            </button>
                        </>
                    ) : (
                        <>
                            <input
                                type="number"
                                step="any"
                                value={analogInputValue}
                                onChange={(e) => {
                                    setAnalogInputValue(e.target.value);
                                    setIsAnalogDirty(true);
                                }}
                                placeholder={getLiveValue() || "live value"}
                                className="dr-control-input"
                            />

                            <button
                                type="button"
                                className="dr-control-btn dr-control-btn--blue"
                                onClick={() => {
                                    const finalValue =
                                        analogInputValue === "" ? getLiveValue() : analogInputValue;

                                    if (typeof onButtonAction === "function") {
                                        onButtonAction({
                                            ...object,
                                            __controlType: "analog",
                                            __controlValue: finalValue,
                                        });
                                    }
                                }}
                            >
                                Write
                            </button>

                            {!isAnalogDirty && getLiveValue() && (
                                <span className="dr-live-badge">live</span>
                            )}
                        </>
                    )}
                </div>
            )}

            {selectedHandles}
        </div>
    );
};

export default TagRenderer;